(function ($) {
    /**
     *
     * @returns {*}
     */
    $.fn.productionBox = function (pallet, data = null) {
        return this.each(function () {
            let box = this;
            box.pallet = pallet;
            box.accordion = null;
            box.batches = new Set();
            box.batchesContainer = null;
            box.batchName = null;
            box.boxContainer = null;
            box.boxHeader = null;
            box.boxId = null;
            box.btnDelete = null;
            box.btnNewBatch = null;
            box.btnPrint = null;
            box.btnSave = null;
            box.fieldBatches = null;
            box.fieldGrossWeight = null;
            box.fieldMeasurements = null;
            box.fieldMeters = null;
            box.fieldNettoWeight = null;
            box.fieldReels = null;
            box.fieldSpoolWeight = null;
            box.form = null;
            box.grossWeight = 0;
            box.identifier = null;
            box.labelSettings = null;
            box.measurements = null;
            box.meters = 0;
            box.printer = null;
            box.reelsCount = 0;
            box.showMeters = null;
            box.showNumber = null;
            box.spoolWeight = 0;
            box.number = null;
            box.picked = null;

            /**
             *
             */
            box.init = (data) => {
                box.initData();
                box.initElements();
                box.initButtons();
                box.setFields();
                box.setData(data);
                box.postInit();
            }

            /**
             *
             */
            box.initData = () => {
                box.identifier = crypto.randomUUID();
                box.labelSettings = box.pallet.production.getLabelSettings('box');
                box.showMeters = box.labelSettings.meters === true;
            }

            /**
             *
             */
            box.postInit = () => {
                box.accordion = $(box).productionAccordion($('> .title.folder-open', $(box)), $('.box-container', $(box)));
                $(box).productionAccordion($('.batches-card > .title.folder-open', box), $('.batches-card .production-batches', box));
            }

            /**
             *
             */
            box.initElements = () => {
                box.form = $('form.box-form', $(box));

                box.batchesContainer = $('div.production-batches', $(box));
                box.btnDelete = $('i.sf-delete.box-delete', $(box));
                box.btnNewBatch = $('button.new-batch', $(box));
                box.btnPrint = $('button.box-print', $(box));
                box.btnSave = $('button.box-save', $(box));
                box.fieldBatches = $('.batches', box.form);
                box.fieldGrossWeight = $('[name="gross_weight"]', box.form);
                box.fieldMeasurements = $('[name="measurements"]', box.form);
                box.fieldMeters = $('[name="meters"]', box.form);
                box.fieldNettoWeight = $('.netto_weight', box.form);
                box.fieldReels = $('[name="reels"', box.form);
                box.fieldSpoolWeight = $('[name="spool_weight"]', box.form);
                box.showNumber = $('span.box-no', $(box));

                box.setNumber();

                box.fieldGrossWeight.off('change blur').on('change blur', function () {
                    box.setGrossWeight($(this).val().replace(',', '.'));
                });

                box.fieldMeters.off('change blur').on('change blur', function () {
                    box.setMeters($(this).val().replace(',', '.'));
                });

                box.fieldReels.off('change blur').on('change blur', function () {
                    box.setReels($(this).val());
                });

                box.fieldSpoolWeight.off('change blur').on('change blur', function (event) {
                    if ($(event.relatedTarget).is('button.btn.btn-success.spool-print-next')) {
                        return;
                    }
                    box.setSpoolWeight($(this).val().replace(',', '.'));
                });

                box.btnDelete.off('click keydown').on('click keydown', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    box.delete(event);
                });

                {
                    if (box.showMeters === false) {
                        $('tr.meters', box.form).hide();
                    }
                }
            }

            /**
             *
             */
            box.initButtons = () => {
                box.btnNewBatch.off('click keydown').on('click keydown', () => {
                    box.newBatch();
                    window.blur();
                });
                box.btnSave.off('click keydown').on('click keydown', () => {
                    box.save();
                    window.blur();
                });
                box.btnPrint.off('click keydown').on('click keydown', () => {
                    box.save(() => {
                        box.print();
                    });
                    window.blur();
                });
            }

            /**
             *
             */
            box.setFields = () => {
                box.setGrossWeight();
                box.setMeters();
                box.setNettoWeight();
                box.setSpoolWeight();
            }

            /**
             *
             */
            box.newBatch = (data = null, index) => {
                box.batches.forEach((batch) => {
                    batch.accordion.close();
                });
                let template = $('#batch-template').html();
                let newElement = $(template).appendTo(box.batchesContainer);
                let batch = newElement.productionBatch(this, data);
                box.batches.add(batch);
            }

            /**
             *
             * @returns {{box_id: *, product_id: *, spool_weight: *, sales_order_id: *, gross_weight: *, reels: *, pallet_id: *, meters: *}}
             */
            box.getData = () => {
                return {
                    box_id: box.getBoxId(),
                    number: box.getNumber(),
                    batch_id: box.getBatchId(),
                    netto_weight: box.getNettoWeight(),
                    measurements: box.getMeasurements(),
                    meters: box.getMeters(),
                    pallet_id: box.getPalletId(),
                    product_id: box.getProductId(),
                    reels: box.getReels(),
                    spool_weight: box.getSpoolWeight(),
                    sales_order_line_id: box.getSalesOrderLineId(),
                    batches: box.fieldBatches.text(),
                    code: box.getCode(),
                    customer_code: box.getCustomerCode(),
                    gross_weight: box.getGrossWeight(),
                    pid: box.getPid(),
                    reel_list: box.getReelList(),
                    batch_name: box.getBatchName()
                };
            }

            /**
             *
             * @param callback
             */
            box.save = (callback = null) => {
                box.setSpoolWeight(box.fieldSpoolWeight.val());
                box.setGrossWeight(box.fieldGrossWeight.val());
                box.setMeasurements(box.fieldMeasurements.val());
                box.setMeters(box.fieldMeters.val());

                $.ajax({
                    type: "POST",
                    url: '/admin/box/store',
                    data: box.getData(),
                    dataType: "json",
                    encode: true,
                    success: function (response) {
                        box.setPalletId(response.pallet_id);
                        box.setBoxId(response.box_id);

                        if (callback) {
                            callback();
                        }
                        box.updatePackagingProgress();
                    },
                    error: function (response) {
                        if (response.error !== undefined) {
                            alert(response.error);
                        } else {
                            alert(JSON.parse(response.responseText).message);
                        }
                    }
                })
            }

            /**
             *
             * @returns {*}
             */
            box.getSalesOrderId = () => {
                return box.pallet.getSalesOrderId();
            }

            /**
             *
             * @returns {*}
             */
            box.getSalesOrderLineId = () => {
                return box.pallet.getSalesOrderLineId();
            }

            /**
             *
             * @returns {*}
             */
            box.getProductId = () => {
                return box.pallet.getProductId();
            }

            /**
             *
             * @returns {*}
             */
            box.getPalletId = () => {
                return box.pallet.getPalletId();
            }

            /**
             *
             * @returns {*}
             */
            box.getBatchId = () => {
                return box.pallet.production.getBatchId();
            }

            /**
             *
             * @returns {null|number|*}
             */
            box.getBoxId = () => {
                return box.boxId;
            }

            /**
             *
             * @returns {*}
             */
            box.getCustomerCode = () => {
                return box.pallet.production.getCustomerCode();
            }

            /**
             *
             * @returns {*}
             */
            box.getCode = () => {
                return box.pallet.production.getCode();
            }

            /**
             *
             * @returns {*}
             */
            box.getPid = () => {
                return box.pallet.production.getPid();
            }

            /**
             *
             * @returns {number}
             */
            box.getSpoolWeight = () => {
                return parseFloat(box.spoolWeight);
            }

            /**
             *
             * @returns {Set<any>}
             */
            box.getBatches = () => {
                return box.batches;
            }

            /**
             *
             * @returns {number|*}
             */
            box.getReels = () => {
                return box.reelsCount;
            }

            /**
             *
             * @returns {number|null|*}
             */
            box.getGrossWeight = () => {
                return box.grossWeight;
            }

            /**
             *
             * @returns {number}
             */
            box.getIndex = () => {
                let boxes = box.pallet.production.getBoxes();
                let i = 1;
                let index = null;
                boxes.forEach(function (loopBox) {
                    if (box.identifier === loopBox.identifier) {
                        index = i;
                    }
                    i++;
                });
                return (index ?? i);
            }

            /**
             *
             * @returns {null|*}
             */
            box.getMeasurements = () => {
                return box.measurements;
            }

            /**
             *
             * @returns {number|*}
             */
            box.getMeters = () => {
                if (isNaN(box.meters) || box.meters === undefined) {
                    return null;
                }
                return box.meters;
            }

            /**
             *
             * @returns {number|number|*}
             */
            box.getNettoWeight = () => {
                return box.nettoWeight;
            }

            /**
             *
             * @returns {number}
             */
            box.getNumber = () => {
                return box.number;
            }

            /**
             *
             * @returns {string}
             */
            box.getReelList = () => {
                let boxes = Array.from(box.pallet.production.getBoxes());
                let startSpool = 1;
                let endSpool = 0;

                for (let i = 0; i < boxes.length; i++) {
                    let loopBox = boxes[i];
                    let reels = loopBox.reelsCount || 0;
                    if (loopBox.identifier === box.identifier) {
                        endSpool = startSpool + reels - 1;
                        break;
                    }
                    startSpool += reels;
                }

                return `Spool No. ${startSpool}-Spool No. ${endSpool}`;
            }

            /**
             *
             * @returns {*}
             */
            box.getBatchName = () => {
                return box.pallet.production.getBatchName();
            }

            /**
             *
             */
            box.print = () => {
                let data = box.getData();

                console.log(data)

                let content = box.pallet.production.labelPrinter.getTemplate(box.labelSettings, data, 'box');
                if (content === null) {
                    return false;
                }
                if (box.printer === null) {
                    box.printer = box.pallet.production.labelPrinter.getDeviceByUid(box.pallet.production.labelPrinterBox);
                }
                box.pallet.production.labelPrinter.write(box.printer, content);
            }

            /**
             *
             * @param box_id
             */
            box.setBoxId = (box_id) => {
                box.boxId = parseInt(box_id);
                box.btnDelete.css('display', 'inline-block');
            }

            /**
             *
             */
            box.setBatches = () => {
                if (box.pallet.production.boxOnly) {
                    return;
                }

                let batches = [];
                box.batches.forEach(function (batch) {
                    if (batch === undefined) {
                        return;
                    }
                    batches.push(batch.getBatchName());
                });
                box.fieldBatches.text([...new Set(batches)].join(', '));
            }

            /**
             *
             */
            box.setNumber = (value = null) => {
                box.number = value ?? box.getIndex();
                box.showNumber.text(box.number);
            }

            /**
             *
             * @param data
             */
            box.setData = (data) => {
                if (data !== null) {
                    box.setBoxId(data.id);
                    box.setGrossWeight(data.gross_weight);
                    box.setNettoWeight(data.netto_weight);
                    box.setSpoolWeight(data.spool_weight);
                    box.setMeasurements(data.measurements);
                    box.setNumber(data.number);
                    box.setMeters(data.meters);
                    $.each(data.batches, function (id, batch) {
                        box.newBatch(batch);
                    })

                    box.setBatches();
                    box.setNettoWeight();
                    box.setMeters();
                    box.setReels(data?.reels);
                    box.setPickedStatus(data?.picked);
                } else {
                    box.setNumber();
                    box.newBatch();
                }
            }

            /**
             *
             * @param gross_weight
             */
            box.setGrossWeight = (gross_weight = 0) => {
                let grossWeight = ((parseFloat(gross_weight) > 0) ? parseFloat(gross_weight) : 0);
                box.grossWeight = grossWeight;
                box.fieldGrossWeight.val(((grossWeight > 0) ? grossWeight.toFixed(2) : ''));
            }

            /**
             *
             * @param measurements
             */
            box.setMeasurements = (measurements) => {
                box.measurements = measurements;
                box.fieldMeasurements.val(box.measurements);
            }

            /**
             *
             * @param meters
             */
            box.setMeters = (meters = 0) => {
                let metersAmount = ((parseFloat(meters) > 0) ? parseFloat(meters) : 0);

                if (box.pallet.production.boxOnly) {
                    box.meters = parseInt(box.fieldMeters.val());
                    return;
                }

                if (metersAmount === 0) {
                    box.batches.forEach(function (batch) {
                        if (batch === undefined) {
                            return;
                        }
                        batch.spools.forEach(function (spool) {
                            if (spool === undefined) {
                                return;
                            }
                            if (
                                spool.getSpoolId() !== null && spool.getPickedStatus() !== true
                            ) {
                                metersAmount += spool.getMeters();
                            }
                        });
                    });
                }
                box.meters = metersAmount;
                box.fieldMeters.val(((metersAmount > 0) ? metersAmount.toFixed(2) : ''));
            }

            /**
             *
             */
            box.setNettoWeight = () => {
                let nettoWeight = 0;
                box.batches.forEach(function (batch) {
                    if (batch === undefined) {
                        return;
                    }
                    batch.spools.forEach(function (spool) {
                        if (spool === undefined) {
                            return;
                        }
                        if (spool.getSpoolId() !== null && spool.getPickedStatus() !== true) {
                            nettoWeight += spool.getNettoWeight();
                        }
                    });
                });
                box.nettoWeight = nettoWeight;
                box.fieldNettoWeight.text(((nettoWeight > 0) ? nettoWeight.toFixed(2) + ' kg' : '-'));
            }

            /**
             *
             * @param pallet_id
             */
            box.setPalletId = (pallet_id) => {
                box.pallet.setPalletId(pallet_id);
            }

            /**
             *
             * @returns {null|*}
             */
            box.getPrinter = () => {
                return pallet.production.labelPrinterBox;
            }

            /**
             *
             */
            box.setReels = (initialValue = null) => {
                if (initialValue !== null) {
                    box.reelsCount = parseInt(initialValue);
                    box.fieldReels.val(box.reelsCount);
                    return;
                }

                if (box.pallet.production.boxOnly) {
                    box.reelsCount = parseInt(box.fieldReels.val());
                    return;
                }

                let reels = 0;
                box.batches.forEach(function (batch) {
                    if (batch === undefined) {
                        return;
                    }
                    batch.spools.forEach(function (spool) {
                        if (spool === undefined) {
                            return;
                        }
                        if (spool.getSpoolId() !== null && spool.getPickedStatus() !== true) {
                            reels++;
                        }
                    });
                });
                box.reelsCount = reels;
                box.fieldReels.val(box.reelsCount);
            }

            /**
             *
             * @param spool_weight
             */
            box.setSpoolWeight = (spool_weight = 0) => {
                let spoolWeight = ((parseFloat(spool_weight) > 0) ? parseFloat(spool_weight) : 0);
                box.spoolWeight = spoolWeight;
                box.fieldSpoolWeight.val((spoolWeight > 0) ? spoolWeight.toFixed(3) : '');
                if (box.pallet.production.boxOnly) {
                    return;
                }
                box.batches.forEach((batch) => {
                    batch.spools.forEach((spool) => {
                        spool.calculateNettoWeight();
                        spool.save(null, false);
                    })
                })
            }

            box.setPickedStatus = (picked, fromParent = false) => {
                const normalized = (picked === true || picked === 1 || picked === '1');
                // Only update the box's own picked state if not coming from a parent override
                if (!fromParent) {
                    box.picked = normalized;
                }
                const effectivePicked = fromParent ? (normalized ? true : (box.picked === true || box.picked === 1 || box.picked === '1')) : (box.picked === true || box.picked === 1 || box.picked === '1');

                if (effectivePicked) {
                    box.btnSave.prop('disabled', true).addClass('disabled');
                    box.fieldGrossWeight.prop('disabled', true);
                    box.fieldMeasurements.prop('disabled', true);
                    box.fieldMeters.prop('disabled', true);
                    box.fieldReels.prop('disabled', true);
                    box.fieldSpoolWeight.prop('disabled', true);
                    box.btnNewBatch.prop('disabled', true).addClass('disabled');
                    box.btnDelete.prop('disabled', true).addClass('disabled');
                    $('i.sf-delete.box-delete', $(box)).css('display', 'none');
                    $('.background-box', $(box)).addClass('disabled');
                    $('.picked-message-row', $(box)).removeClass('d-none');
                } else {
                    box.btnSave.prop('disabled', false).removeClass('disabled');
                    box.fieldGrossWeight.prop('disabled', false);
                    box.fieldMeasurements.prop('disabled', false);
                    box.fieldMeters.prop('disabled', false);
                    box.fieldReels.prop('disabled', false);
                    box.fieldSpoolWeight.prop('disabled', false);
                    box.btnNewBatch.prop('disabled', false).removeClass('disabled');
                    box.btnDelete.prop('disabled', false).removeClass('disabled');
                    $('i.sf-delete.box-delete', $(box)).css('display', 'inline-block');
                    $('.background-box', $(box)).removeClass('disabled');
                    $('.picked-message-row', $(box)).addClass('d-none');
                }

                // Cascade to spools: if the box is effectively picked, disable all spools; otherwise restore each spool to its own state
                box.batches.forEach(function (batch) {
                    if (!batch) { return; }
                    batch.spools.forEach(function (spool) {
                        if (!spool) { return; }
                        // fromParent=true ensures we don't overwrite the spool's own picked state
                        spool.setPickedStatus(effectivePicked, true);
                    });
                });
            }

            /**
             *
             */
            box.delete = () => {
                confirm('Verwijderen?', () => {
                    $.ajax({
                        type: "DELETE",
                        url: '/admin/boxes/' + box.getBoxId(),
                        encode: true,
                        success: function () {
                            box.pallet.deleteBox(box);
                        },
                        error: function (response) {
                            if (response.error !== undefined) {
                                alert(response.error);
                            } else {
                                alert(JSON.parse(response.responseText).message);
                            }
                            return false;
                        }
                    })
                }, null);
            }

            /**
             *
             * @param batchToRemove
             */
            box.deleteBatch = (batchToRemove) => {
                box.batches.forEach((batch) => {
                    if (batch === batchToRemove) {
                        batch.remove();
                        box.batches.delete(batch);
                    }
                })
            }

            box.updatePackagingProgress = () => {
                $.ajax({
                    type: "GET",
                    url: '/admin/production/sales-order-line/packaging/' + box.getSalesOrderLineId() + '/batch/' + box.getBatchId() + '/progress',
                    encode: true,
                    success: function (data) {
                        const response = data?.data;
                        if (response) {
                            $('.packaging-total').text(response.total + ' ' + response.dimension);
                            $('.packaging-progress').text(response.progress + ' ' + response.dimension);

                            let progressBar = $('.packaging-progress-bar');
                            progressBar
                                .css('width', response.percentage + '%')
                                .attr('aria-valuenow', response.percentage)
                                .text(response.percentage + '%');

                            // Remove existing background classes
                            progressBar.removeClass('progress-gray progress-green progress-orange');

                            // Get button for finishing packaging
                            const finishButton = $('#packing-finish-button');

                            // Add an appropriate background class based on percentage
                            let progressBarClass = 'progress-gray';
                            finishButton.removeClass('btn-secondary btn-success disabled').addClass('btn-secondary disabled');
                            if (response.percentage >= 90 && response.percentage < 110) {
                                progressBarClass = 'progress-green';
                                finishButton.removeClass('btn-secondary disabled').addClass('btn-success');
                            } else if (response.percentage >= 110) {
                                progressBarClass = 'progress-orange';
                                finishButton.removeClass('btn-secondary disabled').addClass('btn-success');
                            }
                            progressBar.addClass(progressBarClass);
                        }
                    },
                    error: function (response) {
                        if (response.error !== undefined) {
                            alert(response.error);
                        } else {
                            alert(JSON.parse(response.responseText).message);
                        }
                        return false;
                    }
                })
            }

            box.init(data);

            return box;
        })[0];
    }

}(jQuery));
